import Vue from "vue";
import Vuex from "vuex";
import { route, patch, put } from "@utils/network";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: null,
        address: null,
    },
    
    mutations: {
        SET_USER(state, user) {
            state.user = user ? { ...user } : null;
        },
        SET_ADDRESS(state, address) {
            state.address = address ? { ...address } : null;
        },
    },
    actions: {
        setUser(context, { user }) {
            context.commit("SET_USER", user);
        },
        setAddress(context, { address }) {
            context.commit("SET_ADDRESS", address);
        },
        updateProfile(context, { data }) {
            return new Promise((resolve, reject) => {
                patch(route("users/profile"), { data })
                    .then(response => {
                        context.commit("SET_USER", response.data.result.user)
                        resolve(response)
                    })
                    .catch(error => reject(error));
            });
        },
        updateAddress(context, { data }) {
            return new Promise((resolve, reject) => {
                put(route("addresses/:id", { id: data.id }), { data })
                    .then(response => {
                        context.commit("SET_ADDRESS", response.data.result.address)
                        resolve(response)
                    })
                    .catch(error => reject(error));
            });
        },
        updatePassword(context, { data }) {
            return new Promise((resolve, reject) => {
                patch(route("users/password"), { data })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    },
    getters: {
        user(context) {
            return context.user || {};
        },

        account(context) {
            const { email } = context.user || {};
            return { email };
        },

        profile(context) {
            const { firstname, middlename, lastname, suffix, birthdate, gender, contact_no } = context.user || {};
            return { firstname, middlename, lastname, suffix, birthdate, gender, contact_no };
        },

        address(context) {
            return context.address || {};
        },
    }
});
